<h3 class="white"><span i18n="@@setting.additional_info">Additional Information</span></h3>
<form [formGroup]="additionalInformationFormGroup" (ngSubmit)="saveAdditionalInfo()" class="form-additionalInformation">
	<fieldset [ngClass]="{ 'has-error': additionalInfoSubmit && additionalInformationFormGroup.get('additional_info').errors }">

		<textarea i18n-placeholder="@@business.additional_info_placeholder" placeholder="Example: We are currently offering a 30% discount on all of our cakes and breads bought between the 10th of October 2020 to the 30th of October 2020. Terms and conditions apply." name="additional_info" formControlName="additional_info"  #additional_info></textarea>
		<span class="field-error" *ngIf="additionalInfoSubmit && additionalInformationFormGroup.get('additional_info').errors?.required" i18n="@@error.required">* Required</span>

		<div class="account-setting__actionButtonsWrap">
			<button type="submit" class="tu-btn pink save-btn" i18n="@@button.save">Save</button>
		</div>
	</fieldset>
</form>

<form [formGroup]="businessFormGroup"  (ngSubmit)="onSubmit()">

	<h3 class="white"><span i18n="@@setting.other_information">Other Information</span></h3>

	<fieldset [ngClass]="{ 'has-error': businessFormSubmit && businessFormGroup.get('include_tax').errors }">
		<div class="payments-accepted d-flex">
			<label for="include-tax" i18n="@@business.business_registered_for_vat">Is this business registered for VAT?</label>
			<div class="switch-wrapper">
				<span for="include-tax"  i18n="@@ts.common.yes">Yes</span>
				<div class="switch">
					<input type="checkbox" [checked]="!userDetails.tax_percent" (change)="enableTax($event.target.checked)" id="include-tax" name="include-tax">
					<span class="slider round"></span>
				</div>
				<span for="include-tax" i18n="@@ts.common.no">No</span>
			</div>
		</div>
	</fieldset>

	<fieldset class="quarter" [ngClass]="{ 'has-error': businessFormSubmit && businessFormGroup.get('tax_percent').errors }" *ngIf="isDisable">
		<div class="includeTxn">
			<!-- <div class="check-section">
				<input class="styled-checkbox" id="include-tax" type="checkbox" formControlName="include_tax" #include_tax (change)="enableTax($event.target.checked)">
				<label for="include-tax" i18n="@@invoices.include_tax">Include VAT?</label>
			</div> -->
			<label for="include-tax"><ng-container i18n="@@business.tax_percent">VAT </ng-container></label>
			<div class="input-sections" [ngClass]="{'active' : isDisable,'has-error': businessFormGroup.get('tax_percent').errors?.invalid  }">
				<input type="number" name="tax_percent" formControlName="tax_percent" #tax_percent [attr.disabled]="isDisable ? null : 'disabled'" /><span>%</span>
				<span class="field-error" *ngIf="businessFormSubmit && businessFormGroup.get('tax_percent').errors?.serverError">{{ businessFormGroup.get('tax_percent').errors?.serverError }}</span>
			</div>
        </div>
	</fieldset>

	<fieldset class="oneThird" [ngClass]="{ 'has-error': businessFormSubmit && businessFormGroup.get('tax_number').errors }" *ngIf="isDisable">
		<label><ng-container i18n="@@business.tax_registration">VAT Registration</ng-container></label>
		<input type="text" name="tax_number" formControlName="tax_number"  #tax_number />
		<span class="field-error" *ngIf="businessFormSubmit && businessFormGroup.get('tax_number').errors?.serverError">{{ businessFormGroup.get('tax_number').errors?.serverError }}</span>
		<a [attr.href]="locale == 'en' ? 'https://zatca.gov.sa/en/eServices/Pages/TaxpayerLookup.aspx' : 'https://zatca.gov.sa/ar/eServices/Pages/TaxpayerLookup.aspx'"  target="_blank" i18n="@@business.validate_trn">Validate TRN</a>
	</fieldset>

  <fieldset class="oneThird" [ngClass]="{ 'has-error': businessFormSubmit && businessFormGroup.get('cr_number').errors }" *ngIf="isDisable">
		<label i18n="@@invoices.cr_number">CR Number</label>
		<input type="text" name="cr_number" formControlName="cr_number"  #cr_number />
		<span class="field-error" i18n="@@error.tax_required" *ngIf="businessFormSubmit && businessFormGroup.get('cr_number').errors?.required">Required</span>
		<span class="field-error" *ngIf="businessFormSubmit && businessFormGroup.get('cr_number').errors?.serverError">{{ businessFormGroup.get('cr_number').errors?.serverError }}</span>
	</fieldset>

	<fieldset class="half" [ngClass]="{ 'has-error': businessFormSubmit && businessFormGroup.get('address1').errors }">
		<label>
			<ng-container i18n="@@business.business_address">Business Address</ng-container><span *ngIf="!userDetails.tax_percent" class="req-star">*</span>
		</label>
		<input type="text" name="address1" formControlName="address1" #address1class maxlength="100" />
		<span class="field-error" i18n="@@error.required" *ngIf="businessFormSubmit && businessFormGroup.get('address1').errors?.required">Required</span>
		<span class="field-error" *ngIf="businessFormSubmit && businessFormGroup.get('address1').errors?.serverError">{{ businessFormGroup.get('address1').errors?.serverError }}</span>
	</fieldset>


	<fieldset class="country-wrap half">
		<label i18n="@@business.country">Country</label>
		<select app-select2 [options]="{
				ajax: {url: countryListApi},
				idColumn: 'id',
				textColumn: 'name'
			}" [selected]="selectedCountry ? {id: selectedCountry.id, text: selectedCountry.country_name} : null" i18n-placeholder="@@business.country_placeholder" placeholder="Please type country name" name="country_id" formControlName="country_id">
			<option></option>
		</select>
	</fieldset>

	<div class="account-setting__actionButtonsWrap">
		<button type="submit" class="tu-btn pink save-btn" i18n="@@button.save">Save</button>
	</div>

</form>
